/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Trim_Event_TimeInputs */



/**
* | output |
* | --- |
* | "Auto Trim Event Time" |
*
* @param {Options_Editor_Auto_Trim_Event_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_trim_event_time = /** @type {((inputs?: Options_Editor_Auto_Trim_Event_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Trim_Event_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rogner automatiquement la durée de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Trim-Ereigniszeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo evento di rifinitura automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время события автоматической обрезки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de evento de ajuste automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动修剪事件时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動トリムイベント時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो ट्रिम इवेंट समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Horário do evento de ajuste automático")
	return /** @type {LocalizedString} */ ("Auto Trim Event Time")
});